import { render, staticRenderFns } from "./Sanad.vue?vue&type=template&id=06e6de4a&scoped=true&"
import script from "./Sanad.vue?vue&type=script&lang=js&"
export * from "./Sanad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e6de4a",
  null
  
)

export default component.exports